/**
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email#Validation
 * @param {string} email 
 */
export const isValidEmailAddress = (email) => {
    const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
    return regex.test(String(email).toLowerCase());
}

export const VALID_URL_REGEX_PATTERN = "^(?:http(s)?://)[\\w.-]+(?:\\.[\\w.-]+)+[\\w\\-._~:/?#[\\]@!$&%'()*+,;=.]+$";

export const isValidUrl = (url) => {
    const regex = /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&%'()*+,;=.]+$/gm;
    return regex.test(String(url).toLowerCase());
}

//conditions: code must have at least 1 letter, 1 number or special character, and be at least 7 characters long
export const isValidCode = (code) => {
    const validCodeRegex = new RegExp("^(?=.*[a-zA-Z])((?=.*[0-9])|(?=.*[^a-zA-Z0-9]))(?=.{7,})");
    return validCodeRegex.test(code);
}